import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	ContactDecisionMakerOutreachStatsQuery,
	ContactDecisionMakerOutreachStatsQueryVariables,
} from './api.graphql';
import { ContactDecisionMakerOutreachStats } from './api.graphql';

export async function getDecisionMakerOutreachStats({
	id,
	utilityContext: { gql },
}: {
	id: string;
	utilityContext: UtilityContext;
}): Promise<number | null> {
	const { data } = await gql.fetch<
		ContactDecisionMakerOutreachStatsQuery,
		ContactDecisionMakerOutreachStatsQueryVariables
	>({
		query: ContactDecisionMakerOutreachStats,
		variables: { id },
		rejectOnError: true,
	});

	// `null`, never `undefined`: TanStack Query 5 rejects a query function that resolves undefined and
	// puts the query into an error state. The hook maps it back to `undefined` for its callers.
	return data.petition?.decisionMakerOutreachStats.contactedSupporterCount ?? null;
}
